import moment from "moment"
import { PLAN_TYPE, PLAN_NAME, PLAN_TYPE_TO_NAME } from "../../../constants"
import { formatDate } from "../../../formating"

export default class Plan {
	constructor(attributes) {
		Object.assign(this, attributes)
	}

	get eligible() {
		return "Yes"
	}

	get basicType() {
		if (this.type?.includes("HRA")) {
			return "HRA"
		} else if (this.type === PLAN_TYPE.HFSA) {
			return "FSA"
		} else if (this.type === PLAN_TYPE.DCFSA) {
			return PLAN_NAME.DCFSA
		}
	}

	get validExpenseDates() {
		const expenseDatesByPlan = {}

		expenseDatesByPlan.startDate = formatDate({
			data: this.startDate,
			actions: ["new-date-object"],
			options: ["append-timezone"]
		})

		expenseDatesByPlan.endDate = formatDate({
			data: this.endDate,
			actions: ["new-date-object"],
			options: ["append-timezone"]
		})

		expenseDatesByPlan.lastValidEntryDate = formatDate({
			data: this.lastValidEntryDate,
			actions: ["new-date-object"],
			options: ["append-timezone"]
		})

		expenseDatesByPlan.firstValidDateOfService = formatDate({
			data: this.firstValidDateOfService,
			actions: ["new-date-object"],
			options: ["append-timezone"]
		})

		expenseDatesByPlan.lastValidDateOfService = formatDate({
			data: this.lastValidDateOfService,
			actions: ["new-date-object"],
			options: ["append-timezone"]
		})

		return expenseDatesByPlan
	}

	get accessor() {
		return this.type
	}

	get fieldType() {
		return PLAN_TYPE_TO_NAME[this.type]
	}

	get isCurrentPlan() {
		const today = moment().startOf("day").unix()
		const checkDay = moment().add(15, "days").startOf("day").unix()
		const startDate = moment(this.startDate).startOf("day").unix()
		const endDate = moment(this.endDate).startOf("day").unix()

		return endDate >= today && checkDay >= startDate
	}
}
